export default {
  title: 'Babyferkel',
  babyPigletPrice: 'Babyferkelpreis',
  fattener: 'Aufzüchter',
  priceFormula: 'Preisformel',
  priceFormulaTest: 'Babyferkelpreis testen',
  debitDate: 'Einzugsdatum der Rechnung (Aufzüchter)',
  printFattener: 'Aufzüchter drucken',
  notifications: {
    savePriceFormula: {
      type: 'success',
      message: 'Preisformel erfolgreich gespeichert',
      title: 'Erfolgreich gespeichert'
    }
  }
}
